import { render, staticRenderFns } from "./BigCustomerList.vue?vue&type=template&id=758d2f8a&"
import script from "./BigCustomerList.vue?vue&type=script&lang=js&"
export * from "./BigCustomerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports